import React from 'react';
import styled from 'styled-components';
import { Grid, Paper, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import Redirector from './Redirector';
import DigimagiAppBar from './DigimagiAppBar';

const WrapperGrid = styled(Grid)`
  padding: 60px 40px 24px;
  height: inherit;
`
const ChangePaymentScenePaper = styled(Paper)`
  height: max(100%, 100vh);
`
const PlainLink = styled(Link)`
  text-decoration: none;
`

type ChangePaymentSceneProps = {
  redirected: boolean;
  setRedirected: (value: boolean) => void;
}
const ChangePaymentScene: React.FC<ChangePaymentSceneProps> = ({ redirected, setRedirected }) => {
  if (!redirected) return <Redirector doneRedirect={() => setRedirected(true)} />;
  else return (
    <>
      <DigimagiAppBar setRedirected={setRedirected} parent='UserSettings' />
      <Grid container>
        <Grid item container>
          <Grid item md={12}>
            <ChangePaymentScenePaper square>
              <WrapperGrid container>
                決済方法変更画面
                <Grid item xs={12} container justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <PlainLink to="/userSettings">
                      <Button color='primary'>キャンセル</Button>
                    </PlainLink>
                  </Grid>
                  <Grid item>
                    <Button color='primary'>決定する</Button>
                  </Grid>
                </Grid>
              </WrapperGrid>
            </ChangePaymentScenePaper>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ChangePaymentScene;
